import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import useIsMobile from '../hooks/useIsMobile';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const isMobile = useIsMobile();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await api.post('/auth/forgot-password', { email });
      if (data.success) {
        setSent(true);
      } else {
        setError(data.error || 'Error al enviar solicitud');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Error de conexión');
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      backgroundColor: '#f9fafb', padding: isMobile ? '1rem 0.75rem' : '3rem 1rem',
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, overflow: 'auto'
    }}>
      <div style={{
        maxWidth: '28rem', width: '100%', backgroundColor: 'white',
        borderRadius: '0.5rem', boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)',
        padding: isMobile ? '1.5rem 1rem' : '2rem'
      }}>
        <div style={{ textAlign: 'center', marginBottom: isMobile ? '1.5rem' : '2rem' }}>
          <img src="/logo.png" alt="EnvíaTuPaquete.mx"
            style={{ margin: '0 auto', height: isMobile ? '8rem' : '15rem', marginBottom: '0.5rem' }} />
          <h2 style={{ fontSize: isMobile ? '1.5rem' : '1.875rem', fontWeight: 'bold', color: '#111827' }}>
            Recuperar contraseña
          </h2>
          <p style={{ marginTop: '0.5rem', color: '#6b7280', fontSize: isMobile ? '0.875rem' : '1rem' }}>
            Ingresa tu email y te enviaremos instrucciones
          </p>
        </div>

        {error && (
          <div style={{
            backgroundColor: '#fef2f2', border: '1px solid #fecaca', color: '#991b1b',
            padding: '0.75rem 1rem', borderRadius: '0.375rem', marginBottom: '1rem', fontSize: '0.875rem'
          }}>{error}</div>
        )}

        {sent ? (
          <div>
            <div style={{
              backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0', color: '#166534',
              padding: '1rem', borderRadius: '0.375rem', marginBottom: '1.5rem', fontSize: '0.95rem', lineHeight: '1.6'
            }}>
              Si tu correo está registrado, recibirás un enlace para restablecer tu contraseña.
            </div>
            <div style={{ textAlign: 'center' }}>
              <Link to="/login" style={{ fontWeight: '500', color: '#ff8c00', textDecoration: 'none', fontSize: '0.95rem' }}>
                Volver al inicio de sesión
              </Link>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
            <div>
              <label htmlFor="email" style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#374151', marginBottom: '0.25rem' }}>Email</label>
              <input id="email" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{ width: '100%', padding: '0.625rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '0.375rem', fontSize: '1rem', outline: 'none', boxSizing: 'border-box' }}
                placeholder="tu@email.com" />
            </div>
            <button type="submit" disabled={loading} style={{
              width: '100%', padding: '0.75rem 1rem', backgroundColor: loading ? '#fed7aa' : '#ff8c00',
              color: 'white', fontWeight: '600', borderRadius: '0.375rem', border: 'none',
              cursor: loading ? 'not-allowed' : 'pointer', fontSize: '1rem', transition: 'background-color 0.2s'
            }}>{loading ? 'Enviando...' : 'Enviar instrucciones'}</button>
          </form>
        )}

        {!sent && (
          <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
            <Link to="/login" style={{ fontSize: '0.875rem', fontWeight: '500', color: '#ff8c00', textDecoration: 'none' }}>
              Volver al inicio de sesión
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;
